var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBopsTitleLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1723.384pt",
    height: "482.5639pt",
    viewBox: "0 0 1723.384 482.5639",
    preserveAspectRatio: "xMidYMid",
    id: "svg16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs20"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1,0,0,-0.1,-210.04101,1309.6436)",
    fill: "#7c6cf6",
    stroke: "none",
    id: "g4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 3854,13089 c -427,-38 -841,-226 -1153,-524 -771,-735 -804,-1938 -74,-2716 243,-258 560,-447 904,-538 168,-44 311,-62 494,-62 532,0 1019,207 1385,587 274,285 444,621 515,1019 23,125 31,386 16,515 -77,678 -483,1249 -1094,1540 -311,148 -653,209 -993,179 z m 981,-1100 c 76,-28 156,-108 184,-184 32,-86 29,-193 -8,-270 -32,-69 -100,-137 -169,-168 -47,-22 -49,-22 -913,-25 -866,-2 -866,-2 -892,19 l -27,20 v 295 c 0,281 1,295 20,314 20,20 33,20 885,20 854,0 865,0 920,-21 z m 10,-1017 c 69,-31 138,-103 170,-174 24,-53 27,-70 23,-146 -2,-67 -9,-98 -28,-137 -30,-61 -94,-125 -157,-156 l -48,-24 -877,-3 c -869,-2 -878,-2 -898,18 -19,19 -20,32 -20,312 0,287 0,292 22,315 l 22,23 870,-2 871,-3 z",
    id: "path2"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1,0,0,-0.1,-210.04101,1309.6436)",
    fill: "currentColor",
    stroke: "none",
    id: "g14",
    style: {
      fill: "currentColor",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 7280,13070 c -20,-20 -20,-33 -20,-1890 0,-1857 0,-1870 20,-1890 19,-19 33,-20 283,-20 243,0 265,1 280,18 14,16 17,45 17,190 0,178 7,217 42,227 29,10 51,-3 83,-48 87,-123 243,-256 383,-326 376,-189 910,-150 1267,92 85,58 222,193 287,284 116,160 207,388 250,621 31,171 31,534 0,706 -125,677 -575,1087 -1222,1113 -393,16 -719,-122 -932,-395 -78,-101 -99,-111 -138,-72 -20,20 -20,33 -20,698 0,645 -1,680 -18,695 -16,15 -51,17 -280,17 -249,0 -263,-1 -282,-20 z m 1749,-1499 c 176,-38 320,-125 406,-246 101,-141 143,-300 152,-575 9,-283 -19,-459 -102,-627 -103,-210 -285,-318 -589,-352 -177,-20 -374,-9 -530,29 -254,63 -424,239 -485,500 -55,236 -54,548 3,774 52,202 162,348 328,432 61,31 203,71 293,83 115,16 415,5 524,-18 z",
    id: "path6",
    style: {
      fill: "currentColor",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11795,12139 c -490,-67 -895,-341 -1103,-747 -162,-314 -209,-698 -131,-1059 133,-616 620,-1042 1271,-1112 308,-34 630,24 901,160 120,61 232,144 342,254 205,205 319,417 387,722 30,135 33,490 5,628 -41,199 -117,387 -222,545 -64,96 -258,291 -355,357 -158,107 -367,193 -568,234 -113,23 -415,34 -527,18 z m 525,-568 c 62,-13 128,-36 190,-67 209,-103 323,-289 360,-587 18,-144 8,-475 -19,-589 -67,-293 -223,-458 -496,-528 -126,-33 -328,-46 -487,-32 -242,21 -387,74 -506,187 -112,105 -172,231 -208,430 -24,139 -24,451 0,589 69,385 254,561 646,616 110,15 411,4 520,-19 z",
    id: "path8",
    style: {
      fill: "currentColor",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15265,12139 c -267,-39 -501,-164 -668,-358 -27,-31 -61,-71 -76,-88 -32,-38 -62,-42 -91,-13 -19,19 -20,33 -20,198 0,161 -2,181 -18,195 -16,15 -51,17 -285,17 -263,0 -266,0 -281,-22 -14,-20 -16,-216 -16,-1888 0,-1595 2,-1869 14,-1886 13,-18 30,-19 276,-22 225,-3 265,-1 286,13 l 24,15 v 673 c 0,746 -3,717 63,717 27,0 39,-8 68,-47 182,-242 439,-387 750,-424 246,-28 540,22 754,129 253,126 454,346 571,623 190,449 174,1079 -37,1501 -62,125 -124,213 -222,315 -184,190 -414,307 -689,347 -112,17 -304,19 -403,5 z m 315,-568 c 383,-82 560,-363 560,-891 0,-514 -163,-787 -525,-880 -189,-49 -509,-49 -699,0 -361,93 -526,367 -526,876 0,445 117,705 373,828 157,76 282,97 542,91 131,-3 206,-9 275,-24 z",
    id: "path10",
    style: {
      fill: "currentColor",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17878,12139 c -160,-19 -363,-84 -480,-155 -276,-168 -416,-460 -378,-787 40,-345 232,-563 595,-676 55,-17 260,-60 455,-96 394,-72 460,-89 540,-137 92,-56 120,-116 120,-258 0,-68 -5,-95 -24,-135 -38,-83 -112,-137 -237,-172 -93,-26 -445,-26 -538,0 -143,41 -244,115 -309,228 -18,32 -39,60 -48,63 -9,3 -137,6 -285,6 h -270 l -24,-25 c -32,-32 -31,-48 8,-142 130,-307 409,-521 787,-603 269,-59 599,-49 855,25 362,105 583,310 666,620 31,113 31,316 0,430 -75,282 -284,467 -616,544 -49,11 -257,50 -461,85 -203,36 -397,75 -429,87 -72,27 -145,96 -162,154 -47,159 -11,311 94,391 92,70 292,105 492,85 123,-12 198,-34 264,-80 52,-36 118,-129 142,-201 27,-81 24,-80 313,-80 159,0 261,4 273,11 39,20 42,55 13,143 -132,400 -435,624 -916,676 -113,12 -329,11 -440,-1 z",
    id: "path12",
    style: {
      fill: "currentColor",
      fillOpacity: 1
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBopsTitleLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bops_title_logo.1fa7dc66b3d9d8dccc4d6f4f76f057b0.svg";